import { RecognitionsDisplayState } from './display.types';

export const getDefaultDisplay = (): RecognitionsDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: RecognitionsDisplayState = getDefaultDisplay();
